
import React, {Component} from 'react';

const notificationStyle = {
    getStyle(){
      return  {
        NotificationItem: { // Override the notification item
          DefaultStyle: { // Applied to every notification, regardless of the notification level
            margin: '10px 5px 2px 1px',
            fontSize:'30px',
            width:'400px',
            textAlign:'center'
          },
        }
      }
    }
  }
  
const NotificationSystemInternal = require('react-notification-system')

class NotificationSystem extends Component {

    addNotification(param){
        return this.refs.notf.addNotification(param)
    }

    clearNotifications(){
      return this.refs.notf.clearNotifications()
    }

    render(){
        return <NotificationSystemInternal ref='notf' style={notificationStyle.getStyle()}/>
    }
}

export default NotificationSystem





// WEBPACK FOOTER //
// ./src/component/element/NotificationSystem.js